/* ==========================================================================
   LAX · EUROTAFF — Motor de la ficha de producto de conversión
   Un solo fichero para las secciones lax-cvr-*. Servido desde el CDN.
   Toda la configuración llega en atributos data- del contenedor: aquí no hay
   Liquid, así que el navegador puede cachearlo entre productos.
   ========================================================================== */
(function () {
  'use strict';

  function n(v, d) { var x = parseInt(v, 10); return isNaN(x) ? (d || 0) : x; }
  function cada(lista, fn) { Array.prototype.forEach.call(lista || [], fn); }

  /* ---------- Carrito del tema (Dawn / Shrine) ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }

  function secciones() {
    var d = drawer();
    return (d && typeof d.getSectionsToRender === 'function')
      ? d.getSectionsToRender().map(function (s) { return s.id; })
      : [];
  }

  function volcar(datos) {
    var destinos = [drawer(), document.querySelector('cart-notification')];
    for (var i = 0; i < destinos.length; i++) {
      if (destinos[i] && typeof destinos[i].renderContents === 'function' && datos && datos.sections) {
        destinos[i].renderContents(datos);
        return true;
      }
    }
    return false;
  }

  function peticion(items) {
    var ruta = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    if (ruta.indexOf('.js') === -1) ruta += '.js';
    var secs = secciones();
    var cuerpo = { items: items };
    if (secs.length) { cuerpo.sections = secs.join(','); cuerpo.sections_url = window.location.pathname; }
    return fetch(ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, datos: j }; });
    });
  }

  var enVuelo = false;

  /* Añade al carrito. /cart/add.js con items[] es ATÓMICO: si falla un
     complemento no se añade nada, así que reintentamos con el principal. */
  function anadir(items, boton, alError, alTerminar) {
    if (!items || !items.length || enVuelo) return;
    enVuelo = true;
    if (alError) alError('');
    if (boton) { boton.classList.add('is-cargando'); boton.setAttribute('aria-busy', 'true'); }

    peticion(items)
      .then(function (res) {
        if (res.ok || items.length < 2) return res;
        /* El pack no cupo entero (p. ej. la pareja se agotó justo ahora): el
           producto principal solo YA NO es un kit, así que va sin "_kit" —
           si no, contaminaría el contador de packs del regalo automático. */
        var solo = { id: items[0].id, quantity: items[0].quantity };
        return peticion([solo]).then(function (r2) {
          if (r2.ok && alError) {
            alError((res.datos && res.datos.description)
              || 'No hemos podido añadir un complemento. Hemos añadido el producto principal.');
          }
          return r2.ok ? r2 : res;
        });
      })
      .then(function (res) {
        if (!res.ok) {
          if (alError) alError((res.datos && (res.datos.description || res.datos.message))
            || 'No se ha podido añadir al carrito.');
          return;
        }
        if (!volcar(res.datos)) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cvr:carrito'));
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lax-cvr' });
        }
      })
      .catch(function () { if (alError) alError('Ha fallado la conexión. Vuelve a intentarlo.'); })
      .then(function () {
        enVuelo = false;
        if (boton) { boton.classList.remove('is-cargando'); boton.removeAttribute('aria-busy'); }
        if (alTerminar) alTerminar();
      });
  }

  /* ======================================================================
     1 · BLOQUE DE COMPRA
     ====================================================================== */
  function iniciarCompra(raiz) {
    if (raiz.dataset.cvrListo === '1') return;
    raiz.dataset.cvrListo = '1';

    var d = raiz.dataset;
    var MONEDA = d.cvrMoneda || '€0,00';
    var UMBRAL = n(d.cvrUmbral);
    var TXT_FALTA = d.cvrTxtFalta || '';
    var TXT_OK = d.cvrTxtOk || '';
    var TXT_ATC = d.cvrTxtAtc || 'Añadir al carrito';
    var PRECIO_BASE = n(d.cvrPrecioBase);
    var carrito = n(d.cvrCarrito);

    function eur(c) {
      return MONEDA.replace('0,00', (Math.round(c) / 100).toFixed(2).replace('.', ','));
    }

    var form = raiz.querySelector('form[action*="/cart/add"]');
    var inputVid = raiz.querySelector('[data-cvr-vid]');
    var btn = raiz.querySelector('[data-cvr-atc]');
    var btnLabel = raiz.querySelector('[data-cvr-atc-label]');
    var btnSep = raiz.querySelector('[data-cvr-atc-sep]');
    var btnPrecio = raiz.querySelector('[data-cvr-atc-precio]');
    var precioUnit = raiz.querySelector('[data-cvr-precio-unit]');
    var kit = raiz.querySelector('[data-cvr-kit]');
    var express = raiz.querySelector('[data-cvr-express]');
    var compraYa = raiz.querySelector('[data-cvr-comprarya]');
    var compraYaTxt = raiz.querySelector('[data-cvr-comprarya-txt]');
    var qty = raiz.querySelector('[data-cvr-qty]');
    var cajaError = raiz.querySelector('[data-cvr-error]');
    var cajaEnvio = raiz.querySelector('[data-cvr-envio]');
    var sticky = raiz.querySelector('[data-cvr-sticky]');
    var stickyPre = sticky ? sticky.querySelector('[data-cvr-sticky-precio]') : null;

    /* La barra fija cuelga de <body>: un transform en cualquier ancestro
       rompería position:fixed. */
    if (sticky && document.body) {
      /* Al recargar la seccion en el editor se apilaban barras viejas en <body>. */
      cada(document.querySelectorAll('[data-cvr-sticky]'), function (v) {
        if (v !== sticky && v.parentNode === document.body) v.parentNode.removeChild(v);
      });
      document.body.appendChild(sticky);
    }

    /* ---------- Galería ---------- */
    (function () {
      var pista = raiz.querySelector('[data-gal-pista]');
      var puntos = raiz.querySelectorAll('[data-gal-ir]');
      if (!pista || !puntos.length) return;
      cada(puntos, function (p) {
        p.addEventListener('click', function () {
          pista.scrollTo({ left: n(p.dataset.galIr) * pista.clientWidth, behavior: 'smooth' });
        });
      });
      var t;
      pista.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
          cada(puntos, function (p, j) { p.classList.toggle('is-on', j === i); });
        }, 70);
      }, { passive: true });
    })();

    /* ---------- Estado ---------- */
    function cantidad() { return Math.max(1, n(qty && qty.value, 1)); }
    function nivel() { return kit ? kit.querySelector('input:checked') : null; }
    function base() {
      var n1 = kit ? kit.querySelector('input[value="1"]') : null;
      return n1 ? n(n1.dataset.precio) : PRECIO_BASE;
    }
    function items() {
      var sel = nivel(), lista = null;
      if (sel) { try { lista = JSON.parse(sel.dataset.items); } catch (e) { lista = null; } }
      if (!lista || !lista.length) lista = [{ id: n(inputVid && inputVid.value), quantity: 1 }];
      lista[0].quantity = cantidad();
      if (sel && sel.value !== '1') {
        /* Si el ajuste de nombre se deja vacío, un nivel > 1 marca la línea
           igual: si no, se añadiría al carrito sin "_kit" y el cliente
           perdería el regalo automático que la ficha le prometió. */
        var nombreKit = sel.dataset.nombre || ('Kit nivel ' + sel.value);
        for (var i = 0; i < lista.length; i++) lista[i].properties = { _kit: nombreKit };
      }
      return lista;
    }

    function error(msg) {
      if (!cajaError) { if (msg) alert(msg); return; }
      cajaError.textContent = msg || '';
      cajaError.hidden = !msg;
    }

    /* Regalos (dos escalones) y envío: la config viene de window.LAX_REGALO
       (snippets/lax-regalo-datos.liquid). */
    function regaloConfig() { var R = window.LAX_REGALO; return (R && R.activo) ? R : null; }
    function listaRegalos() { var R = regaloConfig(); return (R && R.regalos) ? R.regalos : []; }
    function kitElegido() { var sel = nivel(); return !!(sel && sel.value !== '1'); }
    function regaloOk(g, precio, esKit) { return precio >= g.umbral || (!!g.conKit && esKit); }
    function conTexto(t, g, importe, plano) {
      var imp = plano ? eur(importe) : '<b>' + eur(importe) + '</b>';
      return (t || '').replace('[importe]', imp).replace('[regalo]', g.nombre || '');
    }

    /* Extras de cada opción del kit (envío gratis y regalos con el precio
       tachado). El servidor las pinta para cantidad 1 y la variante inicial;
       aquí se recalculan si cambia la cantidad, la variante o la opción. */
    function tarifaEnvio(gramos) {
      var R = regaloConfig();
      var filas = ((R && R.tarifas) || '').split(',');
      var kg = gramos / 1000;
      for (var i = 0; i < filas.length; i++) {
        var p = filas[i].split(':');
        if (p.length < 2) continue;
        if (kg <= parseFloat(p[0])) return Math.round(parseFloat(p[1]) * 100);
      }
      return 0;
    }
    function pintarExtras() {
      if (!kit) return;
      var R = regaloConfig(), gifts = listaRegalos();
      var q = cantidad();
      var n1 = kit.querySelector('input[value="1"]');
      var pBase = n1 ? n(n1.dataset.precio) : PRECIO_BASE;
      var wBase = n1 ? n(n1.dataset.peso) : 0;
      var uEnvio = R ? R.envio : UMBRAL;
      cada(kit.querySelectorAll('.cvr-kit__op'), function (op) {
        var inp = op.querySelector('input');
        if (!inp) return;
        var precio = n(inp.dataset.precio) + (q - 1) * pBase;
        var peso = n(inp.dataset.peso) + (q - 1) * wBase;
        var esKit = inp.dataset.kit === '1';
        var tarifa = tarifaEnvio(peso);
        var envioOk = uEnvio > 0 && precio >= uEnvio;
        var gratis = 0;
        var xe = op.querySelector('[data-cvr-x="envio"]');
        if (xe) {
          xe.classList.toggle('is-ok', envioOk);
          xe.classList.toggle('is-pago', !envioOk);
          var ve = xe.querySelector('.cvr-kit__xval');
          if (ve) ve.innerHTML = envioOk
            ? (tarifa > 0 ? '<s>' + eur(tarifa) + '</s> ' : '') + '<b>GRATIS</b>'
            : (tarifa > 0 ? eur(tarifa) + ' ' : '') + '<em>gratis desde ' + eur(uEnvio).replace(',00', '') + '</em>';
          if (envioOk) gratis += tarifa;
        }
        gifts.forEach(function (g) {
          var ok = regaloOk(g, precio, esKit);
          var x = op.querySelector('[data-cvr-x="' + g.id + '"]');
          if (x) {
            x.classList.toggle('is-ok', ok);
            x.classList.toggle('is-no', !ok && !!g.conKit);
            x.classList.toggle('is-falta', !ok && !g.conKit);
            var v = x.querySelector('.cvr-kit__xval');
            if (v) v.innerHTML = ok
              ? (g.valor > 0 ? '<s>' + eur(g.valor) + '</s> ' : '') + '<b>GRATIS</b>'
              : '<em>' + (g.conKit ? (R.soloKit || 'solo con el kit') : (R.txt.faltaCorto || 'te faltan [importe]').replace('[importe]', eur(g.umbral - precio))) + '</em>';
          }
          var mini = op.querySelector('[data-cvr-mini-regalo="' + g.id + '"]');
          if (mini) mini.hidden = !ok;
          if (ok) gratis += n(g.valor);
        });
        var gEl = op.querySelector('[data-cvr-gratis]');
        if (gEl) { gEl.textContent = '+ ' + eur(gratis) + ' gratis'; gEl.hidden = !(gratis > 0); }
      });
      var sel = nivel();
      if (sel) pintarSiguiente(n(sel.dataset.precio) + (q - 1) * pBase, sel.dataset.kit === '1');
    }

    /* Mini-apartado bajo el kit: lo siguiente que se desbloquea con la opción elegida. */
    function pintarSiguiente(precio, esKit) {
      var caja = raiz.querySelector('[data-cvr-sig]');
      var R = regaloConfig(), gifts = listaRegalos();
      if (!caja || !R || !gifts.length) return;
      var sig = null;
      for (var i = 0; i < gifts.length; i++) { if (!regaloOk(gifts[i], precio, esKit)) { sig = gifts[i]; break; } }
      caja.classList.toggle('is-ok', !sig);
      function img(g) { return g.img ? '<img class="cvr-sig__img" src="' + g.img + '" alt="" width="36" height="36" loading="lazy">' : ''; }
      var html;
      if (sig) {
        html = img(sig) + '<span class="cvr-sig__cuerpo"><span class="cvr-sig__txt">' + conTexto(R.txt.falta, sig, sig.umbral - precio)
          + (sig.conKit && !esKit ? ' <em>' + (R.txt.sigKit || '') + '</em>' : '')
          + (sig.valor > 0 ? ' <em>· ' + (R.txt.vale || 'vale [valor]').replace('[valor]', eur(sig.valor)) + '</em>' : '')
          + '</span><i class="cvr-sig__barra"><b style="width:' + Math.min(100, Math.round(precio / sig.umbral * 100)) + '%"></b></i></span>';
      } else {
        html = img(gifts[gifts.length - 1]) + '<span class="cvr-sig__cuerpo"><span class="cvr-sig__txt">✓ ' + (R.txt.sigTodo || '') + ': <b>'
          + gifts.map(function (g) { return g.nombre; }).join(' + ') + '</b></span></span>';
      }
      caja.innerHTML = html;
    }

    /* Barra de hitos (solo en fichas sin kit): envío gratis → regalo 1 → regalo 2. */
    function pintarEnvio(total) {
      if (!cajaEnvio) return;
      var R = regaloConfig(), gifts = listaRegalos();
      var barra = cajaEnvio.querySelector('[data-lax-regalo]');
      /* Solo lo que se elige en la ficha: sumar el carrito confundía ("te
         faltan 2 €" con un gel olvidado dentro). El cajón ya cuenta el resto. */
      var suma = total;
      var uEnvio = R ? R.envio : UMBRAL;
      var envioOk = uEnvio > 0 && suma >= uEnvio;
      var esKit = kitElegido();
      if (!barra) {
        if (kit) return;   /* con kit, la info va dentro de cada opción */
        /* Marcado antiguo (solo envío) por si la barra nueva no está. */
        if (!UMBRAL) return;
        var relleno0 = cajaEnvio.querySelector('[data-cvr-envio-relleno]');
        var texto0 = cajaEnvio.querySelector('[data-cvr-envio-txt]');
        if (relleno0) relleno0.style.width = Math.min(100, Math.round(suma / UMBRAL * 100)) + '%';
        if (texto0) texto0.innerHTML = (suma >= UMBRAL) ? TXT_OK : TXT_FALTA.replace('[importe]', '<b>' + eur(UMBRAL - suma) + '</b>');
        cajaEnvio.hidden = false;
        return;
      }
      var tope = Math.max(uEnvio, 1);
      gifts.forEach(function (g) { tope = Math.max(tope, g.umbral); });
      var relleno = barra.querySelector('[data-lr-relleno]');
      if (relleno) relleno.style.width = Math.min(100, Math.round(suma / tope * 100)) + '%';
      var hE = barra.querySelector('[data-lr-hito="envio"]'); if (hE) hE.classList.toggle('is-ok', envioOk);
      barra.classList.toggle('is-envio', envioOk);
      var partes = [], todo = gifts.length > 0, faltaMostrada = false;
      if (uEnvio > 0) {
        partes.push(envioOk ? '<span class="lax-regalo__ok">✓ ' + (R ? R.txt.envioOk : TXT_OK) + '</span>'
          : (R ? R.txt.envioFalta : TXT_FALTA).replace('[importe]', '<b>' + eur(uEnvio - suma) + '</b>'));
      }
      gifts.forEach(function (g) {
        var ok = regaloOk(g, suma, esKit), porKit = ok && suma < g.umbral;
        var h = barra.querySelector('[data-lr-hito="' + g.id + '"]'); if (h) h.classList.toggle('is-ok', ok);
        var f = barra.querySelector('[data-lr-ficha="' + g.id + '"]'); if (f) f.classList.toggle('is-ok', ok);
        var e = barra.querySelector('[data-lr-estado="' + g.id + '"]');
        if (e) e.textContent = ok ? (porKit ? conTexto(R.txt.kit, g, 0, true) : (R.txt.incluido || '')) : (g.condicion || '');
        if (ok) partes.push('<span class="lax-regalo__ok">✓ ' + conTexto(porKit ? R.txt.kit : R.txt.ok, g, 0) + '</span>');
        else {
          todo = false;
          if (!faltaMostrada) { faltaMostrada = true; partes.push(conTexto(R.txt.falta, g, g.umbral - suma)); }
        }
      });
      barra.classList.toggle('is-regalo', todo);
      var texto = barra.querySelector('[data-lr-txt]');
      if (texto) texto.innerHTML = partes.join(' <span class="lax-regalo__sep">·</span> ');
      cajaEnvio.hidden = false;
    }

    function pintar() {
      var sel = nivel(), b = base();
      var total = (sel ? (n(sel.dataset.precio) || b) : b) + (cantidad() - 1) * b;
      if (btnPrecio) btnPrecio.textContent = eur(total);
      if (stickyPre) stickyPre.textContent = eur(total);
      pintarEnvio(total);
      pintarExtras();
      if (kit) cada(kit.querySelectorAll('.cvr-kit__op'), function (l) {
        l.classList.toggle('is-sel', !!l.querySelector('input:checked'));
      });
      /* Los complementos viven en otra seccion (otro ambito Liquid), asi que
         les decimos por evento que hay ya dentro del kit para que no lo vendan
         dos veces. window.cvrKitIds cubre el caso de que ellos arranquen antes. */
      var lista = items();
      var idsKit = lista.map(function (x) { return x.id; });
      window.cvrKitIds = idsKit;
      document.dispatchEvent(new CustomEvent('cvr:kit', { detail: { ids: idsKit } }));

      /* El boton express nativo solo compra UN articulo y salta el carrito:
         ni packs ni regalos. Para esos casos se cambia por "Comprar ahora"
         (añade todo por Ajax, con sus propiedades, y va al pago). */
      var regalosSel = [];
      listaRegalos().forEach(function (g) { if (regaloOk(g, total, kitElegido())) regalosSel.push(g); });
      var multiple = lista.length > 1 || regalosSel.length > 0;
      if (express) express.style.display = multiple ? 'none' : '';
      if (compraYa) {
        compraYa.hidden = !multiple;
        if (multiple) {
          /* Respaldo sin JS: carrito permanente (no admite propiedades de línea). */
          compraYa.setAttribute('href', '/cart/' + lista.map(function (x) {
            return x.id + ':' + (x.quantity || 1);
          }).concat(regalosSel.map(function (g) { return g.variante + ':1'; })).join(','));
          if (compraYaTxt) compraYaTxt.textContent = 'Comprar ahora · ' + eur(total);
        }
      }
    }

    function refrescarCarrito() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { carrito = c.total_price; pintar(); })
        .catch(function () {});
    }

    /* ---------- Variantes ---------- */
    var variantes = null;
    var nodoVar = raiz.querySelector('[data-cvr-variantes]');
    if (nodoVar) { try { variantes = JSON.parse(nodoVar.textContent); } catch (e) { variantes = null; } }

    function refrescarVariante() {
      cada(raiz.querySelectorAll('.cvr-pill'), function (l) {
        l.classList.toggle('is-on', !!l.querySelector('input:checked'));
      });
      if (!variantes) return;
      var elegidas = [];
      cada(raiz.querySelectorAll('[data-cvr-opt]'), function (r) {
        if (r.checked) elegidas[n(r.dataset.cvrOpt) - 1] = r.value;
      });
      var enc = null;
      for (var i = 0; i < variantes.length && !enc; i++) {
        var ok = true;
        for (var j = 0; j < variantes[i].opciones.length; j++) {
          if (elegidas[j] && variantes[i].opciones[j] !== elegidas[j]) { ok = false; break; }
        }
        if (ok) enc = variantes[i];
      }
      if (!enc) return;
      if (inputVid) inputVid.value = enc.id;
      /* La URL tiene que llevar la variante: si algo recarga la pagina (el modal
         de upsell heredado lo hace) el cliente debe volver a SU medida. */
      if (window.history && history.replaceState && enc.id) {
        try {
          var u = new URL(window.location.href);
          if (u.searchParams.get('variant') !== String(enc.id)) {
            u.searchParams.set('variant', enc.id);
            history.replaceState({}, '', u.toString());
          }
        } catch (e) {}
      }
      if (precioUnit) precioUnit.textContent = eur(enc.precio);
      var n1 = kit ? kit.querySelector('input[value="1"]') : null;
      if (n1) {
        n1.dataset.precio = enc.precio;
        n1.dataset.items = JSON.stringify([{ id: enc.id, quantity: 1 }]);
        var etq = raiz.querySelector('[data-cvr-kit-precio1]');
        if (etq) etq.textContent = eur(enc.precio);
      }
      if (btn) {
        btn.disabled = !enc.disponible;
        if (btnLabel) btnLabel.textContent = enc.disponible ? TXT_ATC : 'Agotado';
        if (btnSep) btnSep.hidden = !enc.disponible;
        if (btnPrecio) btnPrecio.hidden = !enc.disponible;
      }
    }

    if (compraYa) {
      compraYa.addEventListener('click', function (ev) {
        if (compraYa.dataset.cvrEnviando === '1') { ev.preventDefault(); return; }
        ev.preventDefault();
        compraYa.dataset.cvrEnviando = '1';
        var cabecera = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-LAX-Regalo': '1' };
        function pedir(url, body) {
          return fetch(url, { method: 'POST', headers: cabecera, body: JSON.stringify(body) }).then(function (r) {
            if (!r.ok) throw new Error('cvr-comprarya');
            return r.json();
          });
        }
        /* El regalo se decide con el carrito REAL después de añadir, no con
           la selección sola: si el carrito ya tenía algo (otra visita, otra
           ficha), sumar solo la selección duplicaría líneas de regalo o
           dejaría fuera uno que el total conjunto sí gana. */
        function ajustarRegalos() {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            var gifts = listaRegalos();
            if (!gifts.length) return null;
            var real = 0, nKit = 0, lineas = {};
            cart.items.forEach(function (it) {
              var g = null;
              for (var i = 0; i < gifts.length; i++) { if (gifts[i].variante === it.variant_id) { g = gifts[i]; break; } }
              if (g) { (lineas[g.id] = lineas[g.id] || []).push(it); return; }
              real += it.final_line_price;
              if (it.properties && it.properties._kit) nKit++;
            });
            var esKit = nKit >= 2, updates = {}, hayUpdates = false, anadirGifts = [];
            gifts.forEach(function (g) {
              var ok = regaloOk(g, real, esKit), l = lineas[g.id] || [], p = l[0];
              l.slice(1).forEach(function (it) { updates[it.key] = 0; hayUpdates = true; });
              if (p) {
                if (!ok) { updates[p.key] = 0; hayUpdates = true; }
                else if (p.quantity > 1) { updates[p.key] = 1; hayUpdates = true; }
              } else if (ok) {
                anadirGifts.push({ id: g.variante, quantity: 1, properties: { _regalo: g.nombre || '1' } });
              }
            });
            var pasos = [];
            if (hayUpdates) pasos.push(function () { return pedir('/cart/update.js', { updates: updates }); });
            if (anadirGifts.length) pasos.push(function () { return pedir('/cart/add.js', { items: anadirGifts }); });
            return pasos.reduce(function (prev, fn) { return prev.then(fn); }, Promise.resolve());
          });
        }
        pedir('/cart/add.js', { items: items() })
          .then(ajustarRegalos)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            /* Si el Ajax falla en cualquier paso, el permalink de siempre. */
            compraYa.dataset.cvrEnviando = '';
            window.location.href = compraYa.getAttribute('href');
          });
      });
    }

    cada(raiz.querySelectorAll('[data-cvr-opt]'), function (r) {
      r.addEventListener('change', function () { refrescarVariante(); pintar(); });
    });
    if (kit) kit.addEventListener('change', pintar);
    cada(raiz.querySelectorAll('[data-cvr-cant]'), function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, n(qty.value, 1) + n(b.dataset.cvrCant));
        pintar();
      });
    });
    if (qty && qty.tagName === 'INPUT' && qty.type === 'number') qty.addEventListener('change', pintar);

    function anadirAqui(lista, boton, alError) {
      anadir(lista, boton || btn, alError || error, refrescarCarrito);
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); anadirAqui(items()); });

    if (sticky && btn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -60px 0px' }).observe(btn);
      var sBtn = sticky.querySelector('[data-cvr-sticky-btn]');
      if (sBtn) sBtn.addEventListener('click', function () { anadirAqui(items(), sBtn); });
    }

    /* Puente para la sección de complementos */
    window.cvrAnadir = anadirAqui;
    document.addEventListener('cvr:carrito', refrescarCarrito);

    refrescarVariante();
    pintar();
  }

  /* ======================================================================
     2 · COMPLEMENTOS
     ====================================================================== */
  function iniciarComplementos(raiz) {
    if (raiz.dataset.cvrListo === '1') return;
    raiz.dataset.cvrListo = '1';

    var MONEDA = raiz.dataset.cvrMoneda || '€0,00';
    var TXT_BTN = raiz.dataset.cvrTxtBoton || 'Añadir al carrito';
    function eur(c) { return MONEDA.replace('0,00', (Math.round(c) / 100).toFixed(2).replace('.', ',')); }

    var TXT_EN_KIT = raiz.dataset.cvrTxtEnKit || 'Ya incluido en tu kit';
    var casillas = raiz.querySelectorAll('[data-cvr-comp]');
    var btn = raiz.querySelector('[data-cvr-comp-btn]');
    var total = raiz.querySelector('[data-cvr-comp-total]');
    var caja = raiz.querySelector('[data-cvr-comp-error]');

    function error(msg) {
      if (!caja) { if (msg) alert(msg); return; }
      caja.textContent = msg || '';
      caja.hidden = !msg;
    }

    function elegidas() {
      var out = [];
      cada(casillas, function (c) {
        if (c.checked) out.push({ id: n(c.value), quantity: 1, precio: n(c.dataset.precio) });
      });
      return out;
    }

    function pintar() {
      var sel = elegidas();
      var suma = sel.reduce(function (a, x) { return a + x.precio; }, 0);
      if (btn) {
        btn.disabled = sel.length === 0;
        btn.textContent = sel.length ? TXT_BTN + ' · ' + eur(suma) : TXT_BTN;
      }
      if (total) total.innerHTML = sel.length > 1 ? '<b>' + sel.length + '</b> seleccionados' : '';
      cada(raiz.querySelectorAll('.cvr-comp__it'), function (l) {
        l.classList.toggle('is-sel', !!l.querySelector('input:checked'));
      });
    }

    /* Un complemento que ya viene dentro del nivel de kit elegido se desmarca y
       se bloquea: si no, el cliente paga dos geles y nadie se lo advierte. */
    function marcarEnKit(ids) {
      cada(casillas, function (c) {
        var dentro = ids.indexOf(n(c.value)) !== -1;
        var fila = c.parentElement;
        if (dentro === !!c.disabled) return;
        c.disabled = dentro;
        if (dentro) c.checked = false;
        if (fila) {
          fila.classList.toggle('is-en-kit', dentro);
          fila.style.opacity = dentro ? '.5' : '';
          fila.style.cursor = dentro ? 'default' : '';
          var etq = fila.querySelector('.cvr-comp__esencial');
          if (etq) {
            if (!etq.dataset.cvrTxt) etq.dataset.cvrTxt = etq.textContent;
            etq.textContent = dentro ? TXT_EN_KIT : etq.dataset.cvrTxt;
          }
        }
      });
      pintar();
    }
    document.addEventListener('cvr:kit', function (e) {
      marcarEnKit((e.detail && e.detail.ids) || []);
    });

    cada(casillas, function (c) { c.addEventListener('change', pintar); });

    if (btn) btn.addEventListener('click', function () {
      var sel = elegidas();
      if (!sel.length) return;
      var lista = sel.map(function (x) {
        return { id: x.id, quantity: 1, properties: { _origen: 'complementos' } };
      });
      if (typeof window.cvrAnadir === 'function') { window.cvrAnadir(lista, btn, error); return; }
      anadir(lista, btn, error);
    });

    pintar();
    if (window.cvrKitIds) marcarEnKit(window.cvrKitIds);
  }

  /* ---------- Convivencia con las secciones heredadas del tema ----------
     layout/theme.liquid inyecta lax-pdp-limpieza y lax-tal-vez-te-interesa en
     TODAS las plantillas de producto, tambien en esta, y no se pueden desactivar
     sin editar el tema. Asi que esta plantilla se defiende sola:

     1. lax-pdp-limpieza deja un formulario de pago express huerfano
        (#lax-express-pay). Su montador busca .product-form__buttons, que aqui no
        existe, asi que el form se queda fuera de pantalla pero vivo, cargando un
        segundo <shopify-accelerated-checkout>. Lo retiramos: el nuestro ya esta
        dentro de la caja de compra.
     2. lax-tal-vez-te-interesa se auto-coloca justo detras de la primera seccion
        de #MainContent, o sea entre la caja de compra y los complementos, donde
        compite con nuestro cross-sell. Lo bajamos al final: quien llega hasta
        abajo sin comprar es justo quien necesita otra medida.

     Su recolocacion corre una sola vez (marca data-lax-movido), de modo que no
     se vuelve a mover despues de esto. Todo aqui es idempotente. */
  function convivir() {
    colocarWhatsapp();
    var exp = document.getElementById('lax-express-pay');
    if (exp && exp.dataset.laxPuesto !== '1' && exp.parentNode) {
      exp.parentNode.removeChild(exp);
    }

    var tvi = document.querySelector('[id^="shopify-section-lax-tal-vez"]');
    if (!tvi || tvi.dataset.cvrBajado === '1') return;

    /* Va JUSTO ENCIMA de las resenas: quien no ha comprado arriba todavia puede
       necesitar otra medida, y las resenas cierran la pagina. Si no hubiera
       seccion de resenas, se queda al final de lo nuestro. */
    var res = document.getElementById('cvr-resenas');
    var wrapRes = res && res.closest('[id^="shopify-section"]');
    if (wrapRes && wrapRes !== tvi) {
      tvi.dataset.cvrBajado = '1';
      wrapRes.insertAdjacentElement('beforebegin', tvi);
      return;
    }
    var mias = document.querySelectorAll('.lax-cvr:not(.cvr-sticky)');
    if (!mias.length) return;
    var ultima = mias[mias.length - 1].closest('[id^="shopify-section"]');
    if (!ultima || ultima === tvi) return;
    tvi.dataset.cvrBajado = '1';
    ultima.insertAdjacentElement('afterend', tvi);
  }

  /* lax-pdp-limpieza sube el boton de WhatsApp 104/124px para dejar sitio a la
     barra fija del tema V3. Aqui esa barra no existe: la nuestra mide otra cosa
     y en escritorio ni se pinta, asi que el boton quedaba flotando en el aire.
     Estilo inline porque el heredado va con !important. */
  function colocarWhatsapp() {
    var w = document.querySelector('.rq-whatsapp-chat-container');
    if (!w) return;
    var barra = document.querySelector('[data-cvr-sticky]');
    var hueco = 16;
    if (barra && window.getComputedStyle(barra).display !== 'none') {
      hueco = Math.round(barra.getBoundingClientRect().height) + 12;
    }
    w.style.setProperty('bottom', hueco + 'px', 'important');
  }
  window.addEventListener('resize', colocarWhatsapp);

  /* ---------- Arranque ---------- */
  function iniciar(ambito) {
    var raiz = ambito || document;
    cada(raiz.querySelectorAll('[data-cvr-comprar]'), iniciarCompra);
    cada(raiz.querySelectorAll('[data-cvr-complementos]'), iniciarComplementos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(); convivir(); });
  } else {
    iniciar();
    convivir();
  }
  /* Por si el script heredado se parsea despues que este */
  window.addEventListener('load', convivir);
  /* El editor de temas recarga secciones sueltas */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
